import { useCallback } from 'react'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import { logIncogniaWarning } from '../../utils/observability'

const INCOGNIA_REQUEST_TOKEN_HEADER = 'X-Incognia-Request-Token'

export type IncogniaHeaders = Partial<{
  'X-Incognia-Request-Token': string
}>

const useIncogniaTracking = () => {
  const isIncogniaRequestTokenEnabled = useFeatureSwitch('web_incognia_request_token')

  const getIncogniaRequestHeaders = useCallback(async (): Promise<IncogniaHeaders> => {
    if (!isIncogniaRequestTokenEnabled) return {}

    if (!window.IncogniaWebSdk) {
      logIncogniaWarning('IncogniaWebSdk is not available for generating request token')

      return {}
    }

    try {
      const token = await window.IncogniaWebSdk.generateRequestToken()

      return {
        [INCOGNIA_REQUEST_TOKEN_HEADER]: token,
      }
    } catch (error) {
      logIncogniaWarning('Error generating Incognia request token', { error })

      return {}
    }
  }, [isIncogniaRequestTokenEnabled])

  return { getIncogniaRequestHeaders }
}

export default useIncogniaTracking
